import HTTP from '../../Infra/Http'



export const validateDiscountCode = async (code) => {
  return await HTTP.Post('/api/discounts/validate', { code });
};